import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    inject,
} from '@angular/core'
import { ManageFieldsService } from '@app/feature/manage-fields/manage-fields.service'
import { Field, Workspace, isWorkspaceGlobal } from '@models/ui'
import { TbIconComponent } from '@components-library/tb-icon/tb-icon.component'
import { TbDividerComponent } from '@components-library/tb-divider/tb-divider.component'
import { TbMenuListItemComponent } from '@components-library/tb-menu-list-item/tb-menu-list-item.component'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { WorkspaceFacadeService } from '@services/store-facade'
import { EnvDirective } from '@shared/env.directive'
import { ShowIfOperationCodeMatchExpectedOperationDirective } from '@shared/show-if-operation-code-match-expected-operation.directive'
import { TbMenuListComponent } from '@components-library/tb-menu-list/tb-menu-list.component'
import { TranslocoModule } from '@jsverse/transloco'
import { ModalContainerTypes } from '@components-library/tb-modal-manager/modal-manager.service'
import { ModalLayoutComponent } from '@components-library/tb-modal-manager/modal-layout/modal-layout.component'

@UntilDestroy()
@Component({
    selector: 'app-manage-field-field-options',
    templateUrl: './field-options-menu.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        TranslocoModule,
        TbMenuListComponent,
        ShowIfOperationCodeMatchExpectedOperationDirective,
        TbMenuListItemComponent,
        TbDividerComponent,
        TbIconComponent,
        EnvDirective,
        ModalLayoutComponent,
    ],
})
export class FieldOptionsMenuComponent implements OnInit {
    private readonly manageFieldsService = inject(ManageFieldsService)
    private readonly workspaceFacadeService = inject(WorkspaceFacadeService)

    @Input() field!: Field
    @Input() selectedWorkspace!: Workspace
    @Input() containerLayout!: ModalContainerTypes
    @Input() close!: () => void

    @Output() deleteField = new EventEmitter()

    shareAvailable = false

    get isShareAvailable(): boolean {
        return (
            !this.field.operation_code_entity?.global &&
            !isWorkspaceGlobal(this.selectedWorkspace) &&
            this.shareAvailable
        )
    }

    ngOnInit() {
        this.workspaceFacadeService
            .selectWorkspacesForMove$(
                this.field.field_type_code,
                this.field.operation_code_entity,
                this.field.workspace_guid,
            )
            .pipe(untilDestroyed(this))
            .subscribe((workspacesForMove) => {
                const workspacesForShare = workspacesForMove.filter(
                    (workspace) =>
                        !isWorkspaceGlobal(workspace) &&
                        workspace.guid !== this.field.workspace_guid,
                )
                this.shareAvailable = !!workspacesForShare.length
            })
    }

    editField() {
        this.manageFieldsService.editField(this.field)
    }

    duplicateField() {
        this.manageFieldsService.duplicateField(this.field)
    }
}
